import admins from './admins'
import commons from './commons'

export default V => [
  {
    path: '/users',
    component: V('users/Base'),
    children: [...admins(V), ...commons(V)],
  },
]
